import { gql } from "@apollo/client";

/**
 * GraphQL Query - Fetches catalog accounting systems lookup for Brand Details dropdown.
 */
export const GET_ACCOUNTING_SYSTEMS_LOOKUP = gql`
  query AccountingSystemsLookup {
    accountingSystemsLookup {
      count
      items {
        accountingSystemId
        accountingSystemKey
        accountingSystemName
        accountingSystemIsActive
      }
    }
  }
`;
